import React from 'react';
import { Img } from 'react-image';
import { noImage } from '../../../resources/images';

function PressContact({picture, heading, subheading, email, inqemail, inquiry}) {
    return (
        <div className="pressContactWrapper inqWrapper">
            <ul>
                <li> <span className="pressPicture">
                    <Img src={[picture , noImage]} />
                    </span> </li>
                <li> <h2>{heading}</h2> 
                    <span className="subheading">{subheading}</span>  
                    <span className="email">{email}</span>              
                </li>
                
            </ul>

            <div className="inquiry">
                <h2>{inquiry}</h2>  
                    <span className="email">{inqemail}</span>  
                </div>
            
        </div>
    );
}

export default PressContact;